<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <div class='global-panel' v-loading.body="loading.index" style="padding: 10px">
      <el-row>
        <el-col :span="18">
          <el-card shadow="hover" style="margin: 10px;">
            <div class="global-header">
              <div class="global-title">评优任务</div>
              <div class='global-tbar'>
                <el-button size="small" type="danger"  @click="addEval()">新增</el-button>
                <el-input size="small" v-model="condition.title" placeholder="标题"></el-input>
                <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
              </div>
            </div>
            <el-table :data="evalList" border stripe style="width: 100%" size="mini" highlight-current-row @current-change="handleEvalChange">
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column prop="title" label="标题" min-width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="description" label="描述" min-width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="startTime" label="开始时间" width="150" sortable></el-table-column>
              <el-table-column prop="endTime" label="结束时间" width="150" sortable></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.status==='未开始'" type="warning">{{scope.row.status}}</el-tag>
                  <el-tag v-show="scope.row.status==='进行中'">{{scope.row.status}}</el-tag>
                  <el-tag v-show="scope.row.status==='已结束'" type="info">{{scope.row.status}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200" align="center" fixed="right" v-if="ctrlType=='manage'">
                <template slot-scope="scope">
                  <el-button v-show="scope.row.status==='未开始'" class="global-text-btn-success" size="small" type="text" @click="showEval(scope.row)" style="margin-left: 10px;">编辑</el-button>
                  <el-button v-show="scope.row.status==='未开始'" class="global-text-btn-danger" size="small" type="text" @click="deleteEval(scope.row)">删除</el-button>
                  <el-button v-show="scope.row.status==='未开始'" class="global-text-btn-primary" size="small" type="text" @click="startEval(scope.row)">开始</el-button>
                  <el-button v-show="scope.row.status!=='未开始'" class="global-text-btn-danger" size="small" type="text" @click="breakEval(scope.row)">中止</el-button>
                  <el-button v-show="scope.row.status==='进行中'" class="global-text-btn-warning" size="small" type="text" @click="endEval(scope.row)">结束</el-button>
                  <el-button v-show="scope.row.status==='未开始'" class="global-text-btn-success" size="small" type="text" @click="goEvalSetting(scope.row)">评优设定</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页  -->
            <div v-show="paging.allNum > paging.everySize" class="global-paging">
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
          </el-card>
          <el-card shadow="hover" style="margin: 10px;">
            <div class="global-header">
              <div class="global-title">填报结果</div>
            </div>
            <el-table :data="evalResultList" border stripe style="width: 100%" size="mini" highlight-current-row>
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column prop="seriaNo" label="工号" min-width="100"></el-table-column>
              <el-table-column prop="staffName" label="教职工" min-width="100"></el-table-column>
              <el-table-column prop="score" label="得分" min-width="100" sortable></el-table-column>
              <el-table-column prop="auditor" label="审核人" min-width="100"></el-table-column>
              <el-table-column prop="result" label="评选结果" min-width="100"></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.status==null" type="danger">未填写</el-tag>
                  <el-tag v-show="scope.row.status==='未提交'" type="warning">{{scope.row.status}}</el-tag>
                  <el-tag v-show="scope.row.status==='待审核'">{{scope.row.status}}</el-tag>
                  <el-tag v-show="scope.row.status==='通过'" type="success">{{scope.row.status}}</el-tag>
                  <el-tag v-show="scope.row.status==='驳回'" type="danger">{{scope.row.status}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button v-show="scope.row.status==null" class="global-text-btn-success" size="small" type="text" @click="goEvalFill(scope.row)" style="margin-left: 10px;">填报</el-button>
                  <el-button v-show="scope.row.status==='未提交' || scope.row.status==='驳回'" class="global-text-btn-success" size="small" type="text" @click="editEvalFill(scope.row,false)" style="margin-left: 10px;">编辑</el-button>
                  <el-button v-show="scope.row.status==='未提交' || scope.row.status==='驳回'" class="global-text-btn-danger" size="small" type="text" @click="deleteEvalResult(scope.row)">删除</el-button>
                  <el-button v-show="scope.row.status==='未提交'" class="global-text-btn-primary" size="small" type="text" @click="submitEvalResult(scope.row)">提交</el-button>
                  <el-button v-show="scope.row.status==='待审核' || scope.row.status==='通过'" class="global-text-btn-success" size="small" type="text" @click="editEvalFill(scope.row,true)">查看</el-button>
                  <el-button v-show="scope.row.status==='待审核' && ctrlType=='fill'" class="global-text-btn-warning" size="small" type="text" @click="cancelEvalFill(scope.row,true)">撤回</el-button>
                  <el-button v-show="scope.row.status==='待审核' && ctrlType=='manage'" class="global-text-btn-success" size="small" type="text" @click="passEvalResult(scope.row)">通过</el-button>

                  <el-button v-show="scope.row.status==='通过' && ctrlType=='manage'" class="global-text-btn-warning" size="small" type="text" @click="fillEvalResult(scope.row)">填写结果</el-button>

                  <el-button v-show="(scope.row.status==='待审核' || scope.row.status==='通过') && ctrlType=='manage'" class="global-text-btn-danger" size="small" type="text" @click="revertEvalResult(scope.row)">驳回</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" style="margin: 10px;">
            <div class="global-header">
              <div class="global-title">附件</div>
            </div>
            <el-table :data="attachList" style="width: 100%" row-key="id" border stripe size="mini" >
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column label="附件名" prop="fileName"></el-table-column>
              <el-table-column label="操作" width="80" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button class="global-text-btn-primary" type="text" size="small" @click="downloadEvalAttach(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="visible.editForm" width="400px" v-loading="loading.edit" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="evalForm" :model="currentRecord" label-width="80px" :rules="serverRules" size="small">
        <el-form-item label="标题" prop="title">
          <el-input v-model="currentRecord.title"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="currentRecord.description" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="currentRecord.startTime" type="datetime" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="currentRecord.endTime" type="datetime" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentRecord.note" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-input v-model="currentRecord.status" readonly></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.editForm = false">取 消</el-button>
      <el-button v-show="!visible.readOnly" type="primary" @click="saveEval()">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name: 'Eval',
  data() {
    return {
      ctrlType: '',
      // 遮罩
      loading: {index: false, edit: false, selectStaff: false},
      // 可见
      visible: {editForm: false, selectStaff: false},
      // 分页
      paging: {currPage: 1, everySize: 20, allNum: 0},
      // 数据列表
      evalList: [],
      evalResultList:[],
      attachList: [],
      scopeList: [],
      // 查询条件
      condition: {title:''},
      // 当前记录
      currentRecord: {},
      // 校验规则
      serverRules: {
        title: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        description: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      },
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight - vm.$baize.frameTitleHeight) + 'px';
    vm.ctrlType = this.$route.params.ctrlType;
    vm.findByCondition();
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.ctrlType = this.$route.params.ctrlType;
    this.findByCondition();
  },
  methods: {
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.index = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      params.ctrlType = vm.ctrlType
      // 请求后台
      vm.$http.get('rest/eval/findByCondition', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.index = false;
        // 更新数据
        vm.evalList = response.body.evalList;
        vm.paging = response.body.pagingBean;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    addEval: function () {
      var vm = this;
      vm.currentRecord = {id:null, title:null, description:null, startTime:null, endTime:null, note:null};
      vm.visible.editForm = true;
    },

    showEval: function (record) {
      var vm = this;
      vm.currentRecord = JSON.parse(JSON.stringify(record));
      vm.visible.editForm = true;
    },

    deleteEval: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】记录[' + record.title + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/eval/delete', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.findByCondition(vm.paging.currPage);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    saveEval: function () {
      var vm = this;
      // 校验
      vm.$refs['evalForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['evalForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.currentRecord.startTime = vm.$baize.formatDateToString(new Date(vm.currentRecord.startTime), 'yyyy-MM-dd HH:mm:ss');
        vm.currentRecord.endTime = vm.$baize.formatDateToString(new Date(vm.currentRecord.endTime), 'yyyy-MM-dd HH:mm:ss');
        vm.$http.post('rest/eval/save', vm.currentRecord).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 关闭窗口
          vm.visible.editForm = false;
          // 刷新
          vm.findByCondition(vm.paging.currPage);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });
    },

    startEval: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/eval/start', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findByCondition(vm.paging.currPage);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    endEval: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/eval/end', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findByCondition(vm.paging.currPage);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    breakEval: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/eval/break', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findByCondition(vm.paging.currPage);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    handleEvalChange: function (record) {
      var vm = this;
      vm.findEvalAttach(record);
      vm.findEvalResult(record);
    },

    findEvalAttach: function (record) {
      var vm = this;
      vm.attachList = [];
      vm.currentRecord = record || {};
      if (record) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/eval/findEvalAttach', {params: {evalId: vm.currentRecord.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.attachList = response.body.attachList;
          // 提示
          // vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    downloadEvalAttach: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      let xhr = new XMLHttpRequest();
      xhr.open('POST', '/rest/eval/downloadEvalAttach?id=' + record.id, true);
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = function (event) {
        if (this.readyState === 4 && this.status === 200) {
          // 关闭遮罩
          vm.loading.index = false;
          let contentDisposition = xhr.getResponseHeader('Content-Disposition');
          let index = contentDisposition.indexOf("attachment; filename=");
          let fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState === 4 && this.status !== 200) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
          vm.$baize.handle(vm, {status: this.status, body: this.response});
        }
      };
      xhr.send();
    },

    /**
     * 跳转到评优设定页面
     */
    goEvalSetting: function (record) {
        var vm = this;
        // 作为正常页面打开
        vm.$router.push({path: '/EvalSetting',query: {id: record.id}});
    },

    findEvalResult: function (record) {
      var vm = this;
      vm.evalResultList = [];
      vm.scopeList = [];
      vm.currentRecord = record || {};
      if (record) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/eval/findEvalResult', {params: {evalId: record.id, ctrlType:vm.ctrlType}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.evalResultList = response.body.evalResultList;
          vm.scopeList = response.body.scopeList;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    deleteEvalResult: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】记录吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/eval/deleteEvalResult', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.findEvalResult(vm.currentRecord);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    submitEvalResult: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/eval/submitEvalResult', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findEvalResult(vm.currentRecord);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '提交成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '提交失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    cancelEvalFill: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/eval/cancelEvalFill', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findEvalResult(vm.currentRecord);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    passEvalResult: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/eval/passEvalResult', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findEvalResult(vm.currentRecord);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    fillEvalResult : function (record) {
      var vm = this;
      this.$prompt('请输入结果', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        vm.loading.index = true;
        // 请求后台
        vm.$http.post('rest/eval/fillEvalResult', value, {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.findEvalResult(vm.currentRecord);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });

    },
    revertEvalResult: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/eval/revertEvalResult', null, {params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findEvalResult(vm.currentRecord);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    goEvalFill: function (record) {
      var vm = this;
      vm.$router.push({path: '/EvalFill/'+vm.ctrlType,query: {evalId: vm.currentRecord.id, staffId:record.staffId}});
    },

    editEvalFill: function (record) {
      var vm = this;
      vm.$router.push({path: '/EvalFill/'+vm.ctrlType,query: {evalId: vm.currentRecord.id, staffId:record.staffId, evalResultId:record.id}});
    },
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/app/Eval.vue